import Config from '../Config';
import {RestService} from './RestService';

export const UserService = {
    getAgentList: async function(status_filter){
        return RestService.get(`${Config.get_agents_url}${status_filter ? `&status=${status_filter}`: ''}`, {})
        .then(response => response.json());
    },
    removeAgent: async function(id, headers = {}) {
        return RestService.get(`${Config.remove_agent}id=${id}`, headers)
        .then(response => response.json());
    },
    toggleAgentStatus: async function(id, headers = {}) {
        return RestService.get(`${Config.toggle_user_status}user_id=${id}`, headers)
        .then(response => response.json())
    },
    togglePauseState: async function(id, reason = '', status = "0", headers = {}) {
        return RestService.get(`${Config.toggle_pause_state}user_id=${id}&reason=${reason}&status=${status}`, headers)
        .then(response => response.json())
    },
    updateBottlesReturned: async function(id, bottle_count) {
      return RestService.get(`${Config.update_bottles_returned}id=${id}&bottle_count=${bottle_count}`, {});  
    },
    requestLocationUpdate: async function(id){
        return RestService.get(`${Config.request_user_location}user_id=${id}`, {})
        .then(response => response.json())
    },
    refreshLocation: async function(id) {
      return RestService.get(`${Config.get_user_locations}${id ? "&user_id="+id : ""}`, {})
      .then(response => response.json());
    },
    getStoreList: async function(start, numberItems, filter, sort, direction, status_filter){
        return RestService.get(`${Config.get_stores_url}from=${start}&offset=${numberItems}&filter=${filter}&sort=${sort}&direction=${direction}${status_filter ? `&status=${status_filter}`: ''}`, {})
        .then(response => response.json());
    },
    getStoreContractList: async function(store_id){
        return RestService.get(`${Config.get_contracts_for_store}store_id=${store_id}`, {})
        .then(response => response.json());
    },
    getStoreListWithContracts: async function(start, numberItems, includeContractdetails = true, status_filter){
        return RestService.get(`${Config.get_stores_export}from=${start}&offset=${numberItems}&includeContractdetails=${includeContractdetails}${status_filter ? `&status=${status_filter}` : ''}`, {})
        .then(response => response.json());
    },
    removeStore: async function(id) {
        return RestService.get(`${Config.remove_store}id=${id}`, {})
        .then(response => response.json());
    },
    getTotalCount: async function(type, filter = "", status_filter) {
        return RestService.get(`${Config.total_count}type=${type}&filter=${filter}&data_type=USER${status_filter ? `&status=${status_filter}` : ''}`, {})
        .then(response => response.json());
    },
    addTag: async function(id, tag) {
        return RestService.get(`${Config.add_tag}id=${id}&tag=${tag}`, {})
        .then(response => response.json());
    },
    getCustomers: async function(start, numberItems, filter, sort, direction) {
        return RestService.get(`${Config.get_customers_url}from=${start}&offset=${numberItems}&filter=${filter}&sort=${sort}&direction=${direction}`, {})
        .then(response => response.json());
    },
    getCustomerDetails: async function(id) {
        return RestService.get(`${Config.get_userdetails_url}type=CUSTOMER&id=${id}`, {})
        .then(response => response.json());
    },
    createStore: async function(headers= {}, body) {
        return RestService.post(`${Config.create_store}`, headers, body)
        .then(response => response.json());
    },
    createCustomer: async function(headers= {}, body) {
        return RestService.post(`${Config.create_customer}`, headers, body)
        .then(response => response.json());
    },
    createAgent: async function(id, headers = {}, body) {
        return RestService.post(`${Config.create_agent}newRequest=${id === undefined}`, headers, body)
        .then(response => response.json());
    },
    authenticate: async function(body){
        // return fetch(`${Config.authenticate_url}`, {
        //     method: "POST",
        //     headers: {
        //         "Content-Type": "application/json",
        //     },
        //     body: JSON.stringify(body),
        //   })
        //   .then(response => response.json());
        return RestService.post(`${Config.authenticate_url}`, {}, body)
                .then(response => response.json());
    },
    getCustomerNames: async function(){
        return RestService.get(`${Config.get_customer_names}type=CUSTOMER`, {})
        .then(response => response.json());
    },
    updatePin: async function(headers = {}, body) {
        return RestService.post(`${Config.update_pin}`, headers, body)
        .then(response => response.json());
    },
    updateStoreContract: async function(headers = {}, body) {
        return RestService.post(`${Config.update_store_contract}`, headers, body)
        .then(response => response.json());
    },
    getDocuments: async function(id){
        return RestService.get(`${Config.get_uploaded_documents}id=${id}`, {})
        .then(response => response.json());
    },
    getAvailableStates: async function(){
        return RestService.get(`${Config.get_available_states}`, {})
        .then(response => response.json());
    }
};